import { COMPONENTS } from '../../../components/components.registry';
import { SpellcheckConfig } from '../../../models';

export const DEFAULT_SPELLCHECK_CONFIG: SpellcheckConfig = {
  components: {
    spellcheck: COMPONENTS.PURE.Spellcheck
  }
};
